import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type ScanModel from './scan';
import type SectionModel from './section';

export const GenerationMethods = {
  AUTOMATED: 'AUTOMATED',
  EXPERT_REVIEWED: 'EXPERT_REVIEWED',
};

export default class DeliverableModel extends Model {
  declare [Type]: 'deliverable';
  @attr('string') declare title: string;
  @attr declare description: string;
  @attr('boolean') declare is_featured: boolean;
  @attr('string') declare generation_method: string;
  @attr('string') declare link: string;
  @attr declare created_at: string;
  @attr declare updated_at: string;

  @belongsTo('scan', {
    async: true,
    inverse: 'deliverables',
  })
  declare scan: AsyncBelongsTo<ScanModel>;

  @belongsTo('section', {
    async: true,
    inverse: 'deliverables',
  })
  declare section: AsyncBelongsTo<SectionModel>;

  get fileType() {
    const extenstion = (this.link ?? '').split('.').pop()?.toLowerCase();
    switch (extenstion) {
      case 'pdf':
        return 'PDF';
      case 'doc':
      case 'docx':
        return 'DOCX';
      case 'xls':
      case 'xlsx':
        return 'XLS';
      case 'ppt':
      case 'pptx':
        return 'PPTX';
      case 'zip':
      case 'gz':
        return 'ZIP';
    }
    return undefined;
  }
}
